const translations = {
    'sv-se': {

        'your-application-seo-title': 'Din ansökan | Kortio',
        'application-main-button-text': 'Ansök',
        'application-main-button-text-loading': 'Skickar...',
        'select-input-placeholder': 'Välj...',
        'credit-amount-input-label': 'Önskad kredit',

        'show-more': 'Visa mer',
        'yearly-fee': '{amount} årsavgift', 
        'credit-limit': '{amount} kreditgräns', 
        
        'new-application-header': 'Ansök om {title}',
        'new-application-description': 'Färdigställ din ansökan på 1 minut och få svar direkt',

        'offer-information': 'Info & villkor',
        'offer-credit-limit': 'Kreditgräns',
        'offer-yearly-fee': 'Årsavgift',
        'offer-effective-interest': 'Effektiv ränta',
        'offer-terms': 'Villkor',
        'offer-insurance-terms': 'Försäkringsvillkor',
        'offer-link': 'Länk',
        'offer-sign-application': 'Signera ansökan',

        'approved-header': 'Grattis!',
        'approved-requires-additional-action-description': 'Din ansökan har blivit godkänd! Innan du kan få hem kortet behöver du verifiera dina uppgifter.',
        'approved-requires-additional-action-cta': 'Gå vidare',
        'approved-sign-description': 'Din ansökan har blivit godkänd! Nu behöver du bara signera ansökan med Bank-ID.',
        'approved-no-signing-link': 'Din ansökan har blivit godkänd. Du får en signeringslänk på sms och mail.',

        'manual-redirect-header': 'Nästa steg',
        'manual-redirect-description': 'Slutför din ansökan hos {title}.',
        'manual-redirect-cta': 'Slutför ansökan hos {title}',

        'manual-header': 'Manuell granskning',
        'manual-description': 'Din ansökan har hamnat under manuell granskning. Vi, eller kortutgivaren, kommer att höra av oss på sms och mail när vi har ett besked kring din ansökan.',

        'closed-error-header': 'Din ansökan har blivit stängd.',
        'closed-header': 'Din ansökan har automatiskt blivit stängd.',
        'closed-description': 'Om du fortfarande är intresserad av {title} så måste du göra en ny ansökan.',

        'denied-header': 'Din ansökan blev tyvärr nekad.',
        'denied-debit-description': 'Om du fortfarande är intresserad av ett kort, så rekommenderar vi här ett alternativt debetkort utan kreditupplysning och möjlighet till att koppla på en kredit.',
        'denied-cards-header': 'Alternativa kort',
        'denied-cards-description': 'Om du fortfarande är intresserad av ett kort, så listar vi några alternativ nedan. Om du väljer ett kort med UC kommer det att tas en ny kreditupplysning.',
        'denied-lenders-header': 'Alternativa krediter',
        'denied-lenders-description': 'Om du fortfarande är intresserad av en kredit, så listar vi några alternativ nedan. Om du väljer en kredit med UC kommer det att tas en ny kreditupplysning.',

        'pending-header': 'Häng kvar, vi kollar din ansökan just nu.',
        'pending-description': 'Vanligtvis tar det ungefär 1 minut, men vi jobbar så snabbt vi kan.',
        'pending-description-timer-triggered': 'Det verkar ta lite tid, har du bråttom iväg så hör vi av oss på sms inom några minuter med besked kring din ansökan.',

        'signed-header': 'Grattis, allt klart!',
        'signed-description-loan': 'Din ansökan hos {title} är signerad och godkänd. Din lånansökan är färdig och du kommer inom kort få pengarna utbetalt.',
        'signed-description-card': 'Du kommer inom ett par dagar få information från {title} gällande leverans av kortet.',
        'signed-card-tip-html': '<b>Tips:</b> Du kan ofta lägga till kortet på Apple Pay eller Google Pay direkt genom deras app.',

        'signed-card-signed': 'Signerat',

        'error-header': 'Det tar lite tid.',
        'error-description': 'Din ansökan tar lite längre tid än vanligt. Vi hör av oss på sms när vi har besked kring din ansökan.',

        'faq-header': 'Vanliga frågor',
        'faq-card-terms': 'Vad är det för villkor hos {title}?',

        'terms-credit': 'Avtalsvillkor',
        'terms-insurance': 'Försäkringsvillkor',

        'error-from-api': 'Något gick fel: {message}',
        'error-from-api-default': 'Något gick fel. Kontakta vår kundtjänst.',
    },
    'no': {

        'your-application-seo-title': 'Din søknad | Kortio',
        'application-main-button-text': 'Søk nå',
        'application-main-button-text-loading': 'Sender søknaden...',
        'select-input-placeholder': 'Velg...',
        
        'credit-amount-input-label': 'Ønsket kredittgrense',

        'show-more': 'Vis mer',
        'yearly-fee': '{amount} i årsgebyr', 
        'credit-limit': '{amount} i kredittgrense', 
        
        'new-application-header': 'Søk om {title}',
        'new-application-description': 'Fullfør din søknad på 1 minutt og få svar umiddelbart',

        'offer-information': 'Informasjon og vilkår',
        'offer-credit-limit': 'Kredittgrense',
        'offer-yearly-fee': 'Årsgebyr',
        'offer-effective-interest': 'Effektiv rente',
        'offer-terms': 'Vilkår',
        'offer-insurance-terms': 'Forsikringsvilkår',
        'offer-link': 'Link',
        'offer-sign-application': 'Signer søknaden',

        'approved-header': 'Gratulerer!',
        'approved-requires-additional-action-description': 'Din søknad har blitt godkjent. Før du får tilsendt det nye kortet, må du verifisere deg.',
        'approved-requires-additional-action-cta': 'Gå videre',
        'approved-sign-description': 'Din søknad er godkjent! Nå trenger du bare å signere søknaden med Bank-ID.',
        'approved-no-signing-link': 'Din søknad er godkjent. Du få en signeringslenke på SMS og mail.',

        'manual-redirect-header': 'Neste steg',
        'manual-redirect-description': 'Fullfør din søknad hos {title}.',
        'manual-redirect-cta': 'Fullfør søknaden hos {title}',

        'manual-header': 'Manuell gjennomgang',
        'manual-description': 'Søknaden er sendt til manuell gennomgang. Vi, eller kortutstederen, vil kontakte deg på SMS og mail når vi har en oppdatering om søknaden din.',

        'closed-error-header': 'Din søknad har stengt.',
        'closed-header': 'Din søknad har automatisk blitt stengt.',
        'closed-description': 'Om du fortsatt er interessert av {title} så må du gjøre en ny søknad.',

        'denied-header': 'Søknaden din ble dessverre avslått.',
        'denied-debit-description': 'Om du fortsatt er interessert i et kort, anbefaler vi et debetkort.',
        'denied-cards-header': 'Andre alternative kredittkort',
        'denied-cards-description': 'Om du forstatt er interessert av et kredittkort, har vi listet noen alternativer under.',
        'denied-lenders-header': 'Andre alternative kreditter',
        'denied-lenders-description': 'Om du fortsatt er interssert av kreditt, har vi listet noen alternativer under.',

        'pending-header': 'Bli værende, vi sjekker din søknad nå. ',
        'pending-description': 'Normalt tar det rundt 1 minutt, men vi jobber så fort vi kan. ',
        'pending-description-timer-triggered': 'Det ser ut til å ta litt tid. Har du det travelt, kontakter vi deg på SMS i løpet av få minutter med beksjed om søknaden din. ',

        'signed-header': 'Gratulerer! Alt er fullført',
        'signed-description-loan': 'Din søknad hos {title} er signert og godkjent. Din søknad om lån er fullført og du kommer få pengene utbetalt innom kort tid.',
        'signed-description-card': 'Innom ett par dager kommer du få informasjon fra {title} om levering av kortet.',
        'signed-card-tip-html': '<b>Tips:</b> Du kan ofte legge til kortet i Apple Pay eller Google Pay direket gjennom deres app. ',

        'signed-card-signed': 'Signert',

        'error-header': 'Det ser ut til å ta litt tid.',
        'error-description': 'Søknaden din ser ut til å ta litt lengre tid enn vanlig. Vi kontakter deg på SMS så snart vi har en oppdatering.',

        'faq-header': 'Vanlige spørsmål',
        'faq-card-terms': 'Hva er vilkårene hos {title}?',

        'terms-credit': 'Avtalevilkår',
        'terms-insurance': 'Forsikringsvilkår',

        'error-from-api': 'Noe har gått galt {message}',
        'error-from-api-default': 'Noe har gått galt. Ta kontakt med vår kundeservice.',
    }
};

export default ({ app }, inject) => {

    const translateApplication = (key, replacements = {}) => {
        const locale = app.$isSweden() ? 'sv-se' : 'no';
        let translation = translations[locale][key];

        if (! translation) {

            const errorMessage = `Missing application translation for key: '${key}' in locale: '${locale}'`;
            if (app.$bugsnag) {
                app.$bugsnag.notify(new Error(errorMessage));
            }
            else {
                console.error(errorMessage);
            }
            return '';
        }

        if (replacements) {
            for (const [key, value] of Object.entries(replacements)) {
                translation = translation.replace(`{${key}}`, value);
            }
        }

        return translation;
    };

    inject('translateApplication', translateApplication);
};

